'use client';
import { rem } from '@s7/styles';

var defaultProps = {
    size: "xs1",
    color: "neutral.100",
    sizes: {
        xs1: rem(10),
        sm1: rem(12),
        md1: rem(12)
    },
    heights: {
        xs1: rem(14),
        sm1: rem(16),
        md1: rem(16)
    }
};

export { defaultProps };
